/* tslint:disable */

import {
  Component,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from "@angular/core";
import Dragger from "@daybrush/drag";
import { hasClass, addClass, removeClass } from "@daybrush/utils";
import { Compbaser } from '../compbaser/compbases';
import { ContainerService } from '../../services';
import { Hiddenlines } from '../../interfaces';
import { MAX_GUIDELINES } from '../../containers/editor/scene-blocks/block-constants';
const max_pixel = 10000;

@Component({
    selector: "app-ngx-guidelines",
    styleUrls: ["./ngx-guidelines.component.scss"],
    templateUrl: "./ngx-guidelines.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NgxGuidelinesComponent extends Compbaser  implements AfterViewInit {
  type: "horizontal" | "vertical" = "horizontal";
  zoom = 1;
  scrollPos = 0;
  isHorizontal: boolean = true;
  guidelines = { horizontal: [], vertical: [] };
  hidelines: Hiddenlines;

  @Input() 
  set setGuidelines (i_guidelines) {
    this.guidelines = i_guidelines;
    this.changeDetection();
  }
  @Input()
  set setHidelines (i_hidelines: Hiddenlines) {
    this.hidelines = i_hidelines;
    this.changeDetection();
  }
  @Input() guidelineOpacity = 1;
  @Input() editorWidth;
  @Input() editorHeight;

  
  // @Input() zoom = 1;
  @Output() changeGuidelines: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("guidelinesRefH") guidelinesRefH: ElementRef;
  @ViewChild("guidelinesRefV") guidelinesRefV: ElementRef;
  @ViewChild("adderRefH") adderRefH: ElementRef;
  @ViewChild("adderRefV") adderRefV: ElementRef;
  @ViewChild("rulerRefH") rulerRefH: ElementRef;
  @ViewChild("rulerRefV") rulerRefV: ElementRef;

  constructor (
    private containerService: ContainerService,
    private cd: ChangeDetectorRef
    ) {
    super();
    this.cod(
      this.containerService.zoom.subscribe((z) => {
        if (z) {
          this.zoom = z;
          this.changeDetection(true);
        }
      })
    );
  }

  ngAfterViewInit() {
    new Dragger(this.rulerRefH.nativeElement, {
      container: document.body,
      dragstart: e => {
        this.type = "horizontal";
        this.isHorizontal = true;
        this.dragStartToAdd(e);
      },
      drag: this.drag,
      dragend: this.dragEnd
    });
    new Dragger(this.rulerRefV.nativeElement, {
      container: document.body,
      dragstart: e => {
        this.type = "vertical";
        this.isHorizontal = false;
        this.dragStartToAdd(e);
      },
      drag: this.drag,
      dragend: this.dragEnd
    });
    new Dragger(this.guidelinesRefH.nativeElement, {
      container: document.body,
      dragstart: e => {
        this.type = "horizontal";
        this.isHorizontal = true;
        this.dragStartToChange(e);
      },
      drag: this.drag,
      dragend: this.dragEnd
    });
    new Dragger(this.guidelinesRefV.nativeElement, {
      container: document.body,
      dragstart: e => {
        this.type = "vertical";
        this.isHorizontal = false;
        this.dragStartToChange(e);
      },
      drag: this.drag,
      dragend: this.dragEnd
    });
  }

  public dragStartToAdd = ({ datas, clientX, clientY, inputEvent }) => {
    datas.fromRuler = true;
    if (this.isHorizontal) {
      datas.target = this.adderRefH.nativeElement;
    } else {
      datas.target = this.adderRefV.nativeElement;
    }
    this.dragStart({ datas, clientX, clientY, inputEvent });
  };

  public dragStart = ({ datas, clientX, clientY, inputEvent }) => {
    const rect = this.isHorizontal ? 
      this.guidelinesRefH.nativeElement.getBoundingClientRect(): 
      this.guidelinesRefV.nativeElement.getBoundingClientRect();

    datas.offset = this.isHorizontal ? rect.top : rect.left;
    addClass(datas.target, "dragging");
    this.drag({ datas, clientX, clientY });
    
    inputEvent.stopPropagation();
    inputEvent.preventDefault();
  };

  public drag = ({ datas, clientX, clientY }) => {
    const nextPos = Math.round(
      (this.isHorizontal ? clientY : clientX) - datas.offset
    );
    if (this.isHorizontal) {
      datas.target.style.transform = `translateY(${nextPos}px)`;
    } else {
      datas.target.style.transform = `translateX(${nextPos}px)`;
    }
    return nextPos;
  };

  public dragEnd = ({ datas, clientX, clientY }) => {
    const pos = this.drag({ datas, clientX, clientY });
    const guidelines = this.guidelines[this.type];
    const guidelinePos = Math.round(pos / this.zoom);

    removeClass(datas.target, "dragging");

    if (datas.fromRuler) {
      if (pos >= this.scrollPos && guidelines.indexOf(guidelinePos) < 0) {
        this.guidelines[this.type] = [...guidelines, guidelinePos];
        this.changeGuidelines.emit({
          guidelines: this.guidelines,
          hidelines: this.hidelines
        });
      }
    } else {
      const index = datas.target.getAttribute("data-index");

      if (pos < this.scrollPos || guidelines.indexOf(guidelinePos) > -1) {
        if (this.isHorizontal) {
          const rect = this.guidelinesRefH.nativeElement.getBoundingClientRect();
          const vIndex = this.getClosestIndex((clientX - rect.left) / this.zoom);
          const hIndex = +index + 1 + '';
          // let vIndex = this.guidelines.vertical.findIndex((v) => v > posX);

          // // if dragged line is the lastest slice of horizontal line
          // if (vIndex == -1) {
          //   vIndex = this.guidelines.vertical.length;
          // }
          this.updateHiddenLines(vIndex.start, hIndex, vIndex.end, hIndex);
        } else {
          const rect = this.guidelinesRefV.nativeElement.getBoundingClientRect();
          const hIndex = this.getClosestIndex((clientY - rect.top) / this.zoom);
          const vIndex = +index + 1 + '';
          this.updateHiddenLines(vIndex, hIndex.start, vIndex, hIndex.end);
        }
      } else {
        guidelines[index] = guidelinePos;
      }
      this.guidelines[this.type] = [...guidelines];
      this.changeGuidelines.emit({
        guidelines: this.guidelines,
        hidelines: this.hidelines
      });
    }
  };

  public dragStartToChange = ({ datas, clientX, clientY, inputEvent }) => {
    const target = inputEvent.target;
    if (!hasClass(target, "guideline")) {
      return false;
    }
    datas.target = target;
    datas.fromRuler = false;
    this.dragStart({ datas, clientX, clientY, inputEvent });
  };

  // get linear-gradient background color of vertical guideline
  getBackgroundColorOfVline(ind: number) {
    let lineIndex = [];
    const horizontal = this.guidelines.horizontal;
    const maxIndex = horizontal.length;
    if (!this.hidelines || this.hidelines.vertical.length == 0) {
      return 'linear-gradient(to bottom, red 0%, red 100%)';
    }

    // get horizontal hide line slices
    this.hidelines.vertical.forEach((i_pair) => {
      if (+i_pair.x1 == ind + 1) {
        lineIndex.push({start: +i_pair.y1, end: +i_pair.y2});
      }
    });

    // get position of each hide line slice as percent of 100%
    // lineIndex.sort((a, b) => a - b);
    const lines = this.reArrangeItems(lineIndex, horizontal);
    let linearGradient = 'linear-gradient(to bottom, red 0%,';
    const colors = [];
    lines.forEach((item) => {
      const st = item.start;
      const end = item.end;
      if (st == max_pixel) {
        return;
      }
      if (st == 0) {
        colors.push('transparent 0%');
      } else {
        colors.push('red ' + this.roundPercent(st / +this.editorHeight * 100) + '%');
        colors.push('transparent ' + this.roundPercent(st / +this.editorHeight * 100) + '%');
      }
      if (end == max_pixel) {
        colors.push('transparent 100%');
      } else {
        colors.push('transparent ' + this.roundPercent(end / +this.editorHeight * 100) + '%');
        colors.push('red ' + this.roundPercent(end / +this.editorHeight * 100) + '%');
      }
    });
    colors.push('red 100%');
    linearGradient += colors.join(",") + ")";
    return linearGradient;
  }

  // get linear-gradient background color of horizontal guideline
  getBackgroundColorOfHline(ind: number) {
    let lineIndex = [];
    const vertical = this.guidelines.vertical;
    const maxIndex = vertical.length;

    if (!this.hidelines || this.hidelines.horizontal.length == 0) {
      return 'linear-gradient(to right, red 0%, red 100%)';
    }
    // return 'linear-gradient(to right, red 0%, red 100%)';

    // get horizontal hide line slices
    this.hidelines.horizontal.forEach((i_pair) => {
      if (+i_pair.y1 == ind + 1) {
        lineIndex.push({start: +i_pair.x1, end: +i_pair.x2});
      }
    });

    // set background linear-gradient with each hide line slice as percent of 100%
    const lines = this.reArrangeItems(lineIndex, vertical);
    let linearGradient = 'linear-gradient(to right, red 0%, ';
    const colors = [];
    lines.forEach((item) => {
      const st = item.start;
      const end = item.end;
      if (st == max_pixel) {
        return;
      }
      if (st == 0) {
        colors.push('transparent 0%');
      } else {
        colors.push('red ' + this.roundPercent(st / +this.editorWidth * 100) + '%');
        colors.push('transparent ' + this.roundPercent(st / +this.editorWidth * 100) + '%');
      }
      if (end == max_pixel) {
        colors.push('transparent 100%');
      } else {
        colors.push('transparent ' + this.roundPercent(end / +this.editorWidth * 100) + '%');
        colors.push('red ' + this.roundPercent(end / +this.editorWidth * 100) + '%');
      }
    });
    colors.push('red 100%');
    linearGradient += colors.join(",") + ")";
    return linearGradient;
  }

  // round decimal with 2 digits
  private roundPercent(decimal) {
    return Math.round(decimal * 100) / 100
  }

  // update hidden lines with {x1: x1, y1: y1, x2: x2, y2: y2}
  private updateHiddenLines(x1, y1, x2, y2) {
    // check if exist same x,y in hidden lines
    const ind = this.hidelines[this.type].findIndex((i_pair) => i_pair.x1 == x1 && i_pair.y1 == y1 && i_pair.x2 == x2 && i_pair.y2 == y2);
    if (ind > -1) {
      // if exist, remove
      this.hidelines[this.type].splice(ind, 1);
    } else {
      // if doesn't exist, add new hidden line
      this.hidelines[this.type].push({x1, y1, x2, y2});
    }
  }

  // reset hidden slice lines by removing intersection, by sorting
  private reArrangeItems(data, lines) {
    if (data.length == 0) {
      return [];
    }
    return data
      .map((i_item) => {
        let item = {};
        if (i_item.start == MAX_GUIDELINES) {
          item['start'] = max_pixel;
        } else if (i_item.start == 0) {
          item['start'] = 0;
        } else {
          item['start'] = lines[i_item.start - 1];
        }

        if (i_item.end == MAX_GUIDELINES) {
          item['end'] = max_pixel;
        } else if (i_item.end == 0) {
          item['end'] = 0;
        } else {
          item['end'] = lines[i_item.end - 1];
        }
        return item;
      })
      .sort(function (a, b) { return a.start - b.start || a.end - b.end; })
      .reduce(function (r, a) {
        let last = r[r.length - 1] || [];
        if (last.start <= a.start && a.start <= last.end) {
          if (last.end < a.end) {
            last.end = a.end;
          }
          return r;
        }
        return r.concat(a);
      }, []);
  }

  // get closest adjacent lines of clicked position
  private getClosestIndex(x) {
    let min1 = max_pixel, chosen1 = -1;
    let min2 = max_pixel, chosen2 = -1;
    let lines = this.isHorizontal ? this.guidelines.vertical : this.guidelines.horizontal;
    lines.forEach((line, i) => {
      if (line - x > 0 && line - x < min1) {
        min1 = line - x;
        chosen1 = i;
      }
      if (x - line > 0 && x - line < min2) {
        min2 = x - line;
        chosen2 = i;
      }
    });

    return {
      start: chosen2 == -1 ? '0': chosen2 + 1 + '',
      end: chosen1 == -1 ? MAX_GUIDELINES + '': chosen1 + 1 + ''
    }
  }

  private changeDetection(delay = false) {
    if (delay) {
        setTimeout(() => {
            this.cd.detectChanges();
        });
    } else {
        this.cd.detectChanges();
    }
}
}
